import Vue from 'vue'
import myUtils from './myUtils';

/**
 * 自定义指令 v-reset-page，以解决 iOS 12 中键盘收起后页面底部有留白的问题
 */
Vue.directive('resetPage', {
  inserted () {
    document.body.addEventListener('focusout', () => {
      if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
        //软键盘收起的事件处理
        setTimeout(() => {
          const scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0
          window.scrollTo(0, Math.max(scrollHeight - 1, 0))
        }, 100)
      }
    })
  }
})

/**
 * 自定义指令 v-drag，可在页面上随意拖动元素
 */
Vue.directive("drag", {
  bind(el) {
    const isMobile = myUtils.isMobile();
    if(isMobile){
      dragMobile(el)
    }else{
      dragPC(el)
    }
  }
})


function dragPC(el) {
  //获取当前元素
  let dragBox = el, firstTime='',lastTime=''; 
    dragBox.style.position = 'absolute'; // 拖拽元素使用定位，脱离文档流
    dragBox.onmousedown = e => {
      // document.getElementById('dragbtn')
      el.setAttribute('data-flag',false);
      firstTime = new Date().getTime();
      //鼠标相对元素的位置
      let disX = e.clientX - dragBox.offsetLeft;
      let disY = e.clientY - dragBox.offsetTop;
      document.onmousemove = e => {
        //鼠标的位置减去鼠标相对元素的位置，得到元素的位置
        let left = e.clientX - disX;
        let top = e.clientY - disY;
        let maxLeft = document.body.clientWidth - dragBox.offsetWidth;
        let maxTop = document.body.clientHeight - dragBox.offsetHeight;
        
        if(left > maxLeft){
          left = maxLeft
        }else if(left < 0){
          left = 0;
        }
        if(top > maxTop){
          top = maxTop
        }else if(top < 0){
          top = 0;
        }
        //移动当前元素
        dragBox.style.left = left - 5 + 'px';
        dragBox.style.top = top + 'px';
      };
      document.onmouseup = () => {
        lastTime = new Date().getTime();
        if( (lastTime - firstTime) < 200){
        // document.getElementById('dragbtn')
        el.setAttribute('data-flag',true)
        }
        //鼠标弹起来的时候不再移动
        document.onmousemove = null;
        //预防鼠标弹起来后还会循环（即预防鼠标放上去的时候还会移动）
        document.onmouseup = null;
      };
    }
}

function dragMobile(el) {
  let fixBar = {};
  el.style.touchAction = 'none';
  el.addEventListener('touchstart', (evt) => {
    fixBar.curPos = {
      x: el.offsetLeft || 0,
      y: el.offsetTop || 0
    };
    evt.stopPropagation();
    // evt.preventDefault();
  });

  el.addEventListener('touchmove', (evt) => {
    evt.stopPropagation();
    evt.preventDefault();
    try {
      fixBar.curPos = {
        x: el.offsetLeft,
        y: el.offsetTop
      };

      let gap;

      if (fixBar.lastPos) {
        let _pos = {
          left: '',
          top: ''
        };

        gap = {
          x: evt.changedTouches[0].clientX - fixBar.lastPos.x,
          y: evt.changedTouches[0].clientY - fixBar.lastPos.y
        };

        _pos.left = fixBar.curPos.x + gap.x;
        _pos.top = fixBar.curPos.y + gap.y;


        if (_pos.left <= 0) {
          _pos.left = 0;
        } else if (_pos.left >= (window.screen.width - el.offsetWidth)) {
          _pos.left = window.screen.width - el.offsetWidth;
        }

        if (_pos.top <= 0) {
          _pos.top = 0;
        } else if (_pos.top >= window.screen.height - el.offsetHeight - 60) {
          // 60 防止浏览器没有全屏下载app移入看不见的问题
          _pos.top = window.screen.height - el.offsetHeight - 60;
        }

        // let width = document.documentElement.clientWidth;
        // let height = document.documentElement.clientHeight;
        // // 0:竖屏，1:横屏
        // let rotation = width > height ? 1 : 0;
        el.style.left = _pos.left + 'px';
        el.style.top = _pos.top + 'px';
      }

      fixBar.lastPos = {
        x: evt.changedTouches[0].clientX,
        y: evt.changedTouches[0].clientY
      };
    } catch(e) {
      console.log(e);
    }
  }, { passive: false });

  el.addEventListener('touchend', (evt) => {
    fixBar.lastPos = null;
    evt.stopPropagation();
    // evt.preventDefault();
  });
}